import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-payment-successful',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, TranslateModule, MatIconModule],
  templateUrl: './dialog-payment-successful.component.html',
  styleUrl: './dialog-payment-successful.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogPaymentSuccessfulComponent {}
